import { render } from "./TheTeam.vue?vue&type=template&id=75aca914&scoped=true"
import script from "./TheTeam.vue?vue&type=script&lang=js"
export * from "./TheTeam.vue?vue&type=script&lang=js"

import "./TheTeam.vue?vue&type=style&index=0&id=75aca914&scoped=true&lang=css"

import exportComponent from "/Users/alialsaady/Documents/repos/tandzorggestel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75aca914"]])

export default __exports__